import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateStorageState } from "src/features/storageSlice";
import { hideWhatDoIDoButtonToolTipPos } from "src/functions/componentsFunctions";
import SvgIcon from "../../../shared/minicomponents/SvgIcon";
import ToolTip from "../../minicomponents/ToolTip";
import s from "./HideButtonIcon.module.scss";

const HideButtonIcon = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const hideButtonToolTipPos = hideWhatDoIDoButtonToolTipPos(i18n.language);

  function neverShowMenu() {
    dispatch(updateStorageState({ key: "showWhatDoIDoIcon", value: false }));
  }

  return (
    <div
      className={s.hideIcon}
      data-is-tooltip="true"
      onClick={neverShowMenu}
      aria-haspopup="true"
    >
      <SvgIcon name="xMark" />
      <ToolTip
        top={"-17px"}
        left={hideButtonToolTipPos}
        content={t("tooltips.hidePermanent")}
      />
    </div>
  );
};
export default HideButtonIcon;
